import { gql } from '@apollo/client'

// Curry Me Club — the counter surface (stage 3). Separate from the admin
// programme queries in loyalty-queries.ts: this is what a cashier touches at
// checkout, gated on order.checkout (every cashier has it), not loyalty.manage.

/**
 * The member and reward behind a typed counter code. Returns null when the code
 * is unknown, expired or already used — NOT an error (§5). The code is only
 * consumed when an order row is created; this lookup never spends it.
 */
export const LOOKUP_COUNTER_CODE = gql`
  query LookupCounterCode($code: String!) {
    lookupCounterCode(code: $code) {
      member {
        id
        first_name
        card {
          position
          size
        }
      }
      reward {
        id
        name_nl
        name_en
        reward_type
        expires_at
      }
    }
  }
`
